<template>
    <form class="discount-code-form" aria-label="Discount code form">
            <div class="input-folder">
                <div class="input-folder--input">
                    <input type="text" v-model="localCouponCode" id="discountCode" placeholder=" " aria-label="Enter discount code" required>
                    <label for="discountCode">
                        <p class="paragraph-default">Discount Code</p>
                    </label>
                </div>
                <div class="input-folder"><span class="input-support-text coupon-success" v-if="applied">Code successfully applied to your order!</span></div>
                <div class="input-folder"><span class="input-support-text invalid-state" v-if="couponError">Code is invalid or does not apply to your order</span></div>
            </div>
            <button type="button" @click="applyCoupon" :class="localCouponCode ? `primary` : `bg-rothcoMedGray text-rothcoCharcoal`" aria-label="Apply discount code">
                Apply
            </button>
     </form>
</template>

<script lang="ts" setup>
    import { ref, computed } from "vue";
    import { storeToRefs } from "pinia";
    import { useCheckoutD2CStore } from "@/store/checkoutD2CStore";

    let { couponCode } = defineProps({
        couponCode: {
            type: String<any>,
            default: ""
        }
    });

    const { applyCouponAndRecalculate } = useCheckoutD2CStore();
    const { couponInformation } = storeToRefs(useCheckoutD2CStore());

    let localCouponCode = ref(couponCode);
    const applied = computed(() => !!localCouponCode.value && couponInformation.value?.applied === true);
    const couponError = computed(() => !!localCouponCode.value && couponInformation.value?.applied === false);

    const applyCoupon = function () {
        applyCouponAndRecalculate(localCouponCode.value, true);
    };
</script>
